import { PureComponent } from 'react';

import { isNullable } from '@ipfabric/utils';
import classNames from 'classnames';
import { Button } from 'components/Button/Button';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import handleEvent from 'utils/handleEvent';

export default class CustomFrame extends PureComponent {
  static propTypes = {
    children: PropTypes.element,
    disableEdit: PropTypes.bool.isRequired,
    editable: PropTypes.bool,
    msg: PropTypes.object.isRequired,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    showTitle: PropTypes.bool,
    title: PropTypes.string,
    widgetName: PropTypes.string.isRequired,
  };

  static defaultProps = {
    showTitle: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      showHover: false,
    };
  }

  getTitle = () => {
    const { showTitle, title } = this.props;
    if (!showTitle) {
      return null;
    }
    return <h2>{title}</h2>;
  };

  handleRemoveWidget = handleEvent(() => {
    this.props.onRemove();
  });

  handleEditContainerClick = handleEvent((e) => {
    const { onEdit } = this.props;
    const widgetAction = e.target.getAttribute('data-widgetaction');
    if (isNullable(widgetAction)) {
      onEdit();
    }
  });

  handleMouseEnter = handleEvent(() => {
    if (this.props.editable) {
      this.setState({ showHover: true });
    }
  });

  handleMouseLeave = handleEvent(() => {
    if (this.props.editable) {
      this.setState({ showHover: false });
    }
  });

  render() {
    const { children, disableEdit, editable, msg, widgetName } = this.props;
    const { showHover } = this.state;
    return (
      <div
        className={classNames(
          'inline-block',
          editable && !disableEdit ? 'cursor-pointer' : 'cursor-auto',
          'relative',
          `x_panel fixed_height_320 ${widgetName}-panel`,
        )}
        onClick={
          editable && !disableEdit ? this.handleEditContainerClick : null
        }
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        data-testid={`dashboard-widget-${widgetName}`}
      >
        {editable && showHover ? (
          <div className='dashboard-custom-frame__hover'>
            <div className='text-center'>
              {!disableEdit ? (
                <Button variant='secondary' icon='fa-pen' className='m-2'>
                  {get(msg, ['dazzle', 'editWidget'])}
                </Button>
              ) : null}
              <Button
                accent='negative'
                className='m-2'
                data-widgetaction='1'
                icon='fa-trash-can'
                onClick={this.handleRemoveWidget}
                variant='secondary'
              >
                {get(msg, ['dazzle', 'removeWidget'])}
              </Button>
            </div>
          </div>
        ) : null}
        <div className='x_title'>
          {this.getTitle()}
          <ul
            className={classNames(
              'nav navbar-right panel_toolbox',
              'dashboard-custom-frame__panel-toolbox',
              editable && 'dashboard-custom-frame__panel-toolbox--editable',
            )}
          />
          <div className='flow-root' />
        </div>
        <div className='x_content' data-testid='dashboard-widget-content'>
          {children}
        </div>
      </div>
    );
  }
}
